







import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {LatLon} from './models/LatLon'
import {GoogleMap} from './providers/Google'
import {Base} from './providers/Base'
import {Mapbox} from './providers/Mapbox'
import {Bing} from './providers/Bing'
import {Here} from './providers/Here'
import {Leaflet} from './providers/Leaflet'
import {Openlayers} from './providers/Openlayers'
import {MapInstance} from './models/MapInstance'
import {Baidu} from './providers/Baidu'
import {Yandex} from './providers/Yandex'

@Component({
  components: {},
})
/*
 * TODO:
 *  - Click handler on map https://gis.stackexchange.com/questions/238414/leaflet-how-to-add-a-new-and-remove-an-old-marker-every-time-the-user-click-on
 *  - pan
 *  - zoom
 */
export default class NMap extends Vue {
  // Needed for wrapper component to work
  public isRootNMap: boolean = true

  @Prop() readonly provider!: string
  // Provider specific config
  @Prop() readonly config!: any

  // Common map settings
  @Prop() readonly center!: LatLon
  @Prop({default: 13}) readonly zoomLevel!: number

  // This is used as proxy
  public instance: MapInstance = {
    map: {}, // Need to be an object to be passed as reference!
    ready: false
  }


  public providerInstance!: Base

  public created() {
    this.setUpProvider()
  }

  public setUpProvider() {
    switch (this.provider) {
      case 'google':
        this.providerInstance = new GoogleMap(this.config, this.instance.map)
        break
      case 'mapbox':
        this.providerInstance = new Mapbox(this.config, this.instance)
        break
      case 'bing':
        this.providerInstance = new Bing(this.config, this.instance)
        break
      case 'here':
        this.providerInstance = new Here(this.config, this.instance)
        break
      case 'leaflet':
        this.providerInstance = new Leaflet(this.config, this.instance)
        break
      case 'openlayers':
        this.providerInstance = new Openlayers(this.config, this.instance)
        break
      case 'baidu':
        this.providerInstance = new Baidu(this.config, this.instance)
        break
      case 'yandex':
        this.providerInstance = new Yandex(this.config, this.instance)
        break
    }
  }

  public mounted() {
    if (!this.providerInstance) {
      console.error('NMap', this.provider, 'NOT IMPLEMENTED')
      return
    }
    Promise.all(this.providerInstance.loadResources()).then(this.init)
  }

  public init() {
    if (!this.instance.ready) {
      const mapElement = this.$refs.map as HTMLElement

      this.providerInstance.initMap(mapElement, {
        center: this.center,
        zoom: this.zoomLevel,
      }, () => {
        this.instance.ready = true
        this.$emit('map-ready')

        // Set up click listener
        this.providerInstance.setClickListener((p: LatLon) => {
          console.log('clicked ' + this.provider + ' map', p)
          if (this.$listeners && this.$listeners.click) {
            this.$emit('click', p)
          }
        })
      })
    }
  }

  public pan(p: LatLon) {
    if (!this.instance.map) {
      return
    }
    this.providerInstance.pan(p)
  }

  // Implement destroy

  public $log(message: string, type: string = 'info') {
    if (type === 'info') {
      // @ts-ignore
      console.log(message)
    } else {
      alert(type + ': ' + message)
    }
  }

  @Watch('config', {immediate: true, deep: true})
  public refreshMapView() {
    if (this.providerInstance) {
      this.instance.ready = false
      this.providerInstance.destroy()
      delete this.providerInstance
      this.setUpProvider()
      this.init()
    }
  }

  public beforeDestroy() {
    // console.log('beforeDestroy')
  }
}
